import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { AnalyticEvents } from '@app/enums';
import { validateForm } from '@app/functions/validate-form';
import { AnalyticService, NotifyService } from '@app/services';
import { BaseForm } from '@forms/base.form';
import { WorkSchedule } from '@models/time-off-v3/works-schedule.model';

@Component({
    selector: 'app-work-schedule-overall-settings-form',
    templateUrl: './work-schedule-overall-settings.template.html',
    styleUrls: ['./work-schedule-overall-settings.style.scss'],
})
export class WorkScheduleOverallSettingsForm extends BaseForm {
    @Input() workSchedule: WorkSchedule = new WorkSchedule();
    @Output() loading: EventEmitter<boolean> = new EventEmitter<boolean>();
    @ViewChild('form') form: NgForm;

    constructor(
        private notify: NotifyService,
        private router: Router,
        private analyticService: AnalyticService
    ) {
        super();
    }

    async onSave(): Promise<void> {
        this.loading.emit(true);

        validateForm(this.form);

        if (this.form.invalid) {
            this.loading.emit(false);
            return;
        }

        try {
            await this.workSchedule.save();
            this.analyticService.trackEvent(AnalyticEvents.TimeOffTypesAndPoliciesCreatingWorkSchedule);
            this.notify.success('time-off-v3.workScheduleHasBeenUpdated');
            this.router.navigate(['/', 'time-off', 'v3', 'settings']);
        } catch (e) {
            this.loading.emit(false);
            this.notify.error(e.message);
        }
    }

    onCancel(): void {
        this.workSchedule.revert();
    }
}
